/**
 * 模板区域
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateSelectArea, updateSearchBox } from 'Store/ZoneSetting/action';
import { langCheck } from 'Pub/js/utils';
import platform from "Pub/js/platform";
import { uniqBy } from 'lodash';
const { getLangCode } = platform;

require('./index.less');

const { NCSelect, NCFormControl } = platform.base;
const NCOption = NCSelect.NCOption;
const toLocaleLowerCase = function (str) {
    return String(str).toLocaleLowerCase();
};

/**
 * 清理字符
 * @param {*} str
 * @param {*} rule
 * @param {*} replacer
 */
const replaceStr = function (str, rule = /\.|\&|\#/g, replacer = '') {
    return String(str).replace(rule, replacer);
};

/**
 * 区分大小写之后还需要获取原始字符
 */
const getOriginalStr = function (str, key) {
    let res = String(str).match(new RegExp(`${key}`, 'ig'));
    return res ? res[0] : '';
};

// get nearest parent element matching selector   origin from stackoverflow  add by bbqin
const closest = function (el, selector) {
    if (!el) {
        return null;
    }
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

// 选择器标识
const SIGN = {
    sus: 'search-units-selected',
    sua: 'search-units-active',
    sun: 'search-units-nolabel',
};

const getLabelSelector = function (areaCode, unitCode) {
    return getAreaSelector(areaCode) + getUnitSelector(unitCode) + getUnitLabelSelector();
};

const getAreaSelector = function (areaCode) {
    return ` .search-area-${replaceStr(areaCode)} `;
};

const getUnitSelector = function (unitCode) {
    return ` .search-unit-${replaceStr(unitCode)} `;
};

const getUnitLabelSelector = function () {
    return ` .search-unit-label `;
};

class SearchBox extends Component {
    static defaultProps = {
        select: 'All',
        key: '',
        current: 0,
        total: 0,
        selectOptions: [],
        highlights: [],
        curentSide: {},
        showSide: false,
        areaHide: {},
        areaVisible: {},
    }

    constructor(props) {
        super(props);
        let { sourceData = [], ...others } = props;

        this.state = { ...others };

        this.sourceData = sourceData;
        // 动作锁
        this.lock = false;
    }

    componentDidMount() {
        let { selectOptions = [], relations } = this.handleSourceData();
        this.relations = relations;
        this.setState({ selectOptions });
    }

    componentWillReceiveProps(nextProps) {
        let { sourceData = [], boxStatus = {}, areaHide = {}, areaVisible = {}, areaList = [] } = nextProps;
        let { areaCode: prevAreaCode = {}, areaVisible: prevAreaVisible = {}, areaHide: oldAreaHide, areaVisible: oldAreaVisible, showSide: oldShowSide } = this.state;

        let reset = JSON.stringify(prevAreaCode) !== JSON.stringify(areaHide) ||
            JSON.stringify(prevAreaVisible) !== JSON.stringify(areaVisible) ||
            JSON.stringify(areaList) !== JSON.stringify(this.areaList || []) ||
            boxStatus.reset;

        // 可以考虑判断下数据源 来确定是否更新数据
        this.areaList = JSON.parse(JSON.stringify(areaList));
        this.sourceData = sourceData;
        let { selectOptions = [], relations } = this.handleSourceData({ areaHide, areaVisible });
        this.relations = relations;
        // console.log('search from', relations, sourceData, boxStatus);

        this.setState({
            selectOptions,
            areaHide,
            areaVisible,
            showSide: boxStatus.showSide,
        }, () => {
            // 不要重复高亮
            if ((boxStatus.showSide && boxStatus.showSide !== oldShowSide) ||
                boxStatus.isHighlight ||
                (areaHide && areaHide != oldAreaHide) ||
                (areaVisible && areaVisible !== oldAreaVisible)) {
                this.highlight();
            }

            boxStatus.isHighlight && this.props.updateSearchBox({ isHighlight: false }); // 重置条件

            boxStatus.reset && this.props.updateSearchBox({ reset: false }); // 重置条件

            // 如果数据发生过变化 就进行一次移动重查 比较靠谱些
            if (reset) {
                this.reset = true; // 是否重新查询
            }

            if (boxStatus.isLayout) { // 重新布局
                // 暂时不需要做处理
            }
        });
    }

    // 为了减少遍历 数据处理 单独提取
    handleSourceData({ areaHide = {}, areaVisible = {} } = {}) {
        let sourceData = this.sourceData,
            relations = {
                __side: {},
                __associatedtab: {},
            },
            selectOptions = [],
            newSourceData = [];
        // 先取出tabs
        sourceData.forEach(ele => {
            if (!ele) {
                // 这里是newAreaList 会有空数据
                return;
            }
            newSourceData.push(ele);
            if (ele.tabs) {
                newSourceData = newSourceData.concat(ele.tabs || []);
            }
        });

        newSourceData.forEach(ele => {
            let { code, name, associatedtab, pk_area, groups = [], sides = [], grandsons = [] } = ele;
            if (areaHide[pk_area]) {
                return;
            }
            name = this.getMultiLangName(ele, 'name');
            // 存储  必须先写  有可能 relationcode 和  associatedtab 同时存在
            associatedtab && (relations.__associatedtab[code] = associatedtab);
            selectOptions.push({
                code,
                name,
            });
            // 外层都是主表数据
            relations[code] = {
                sides: [],
                groups: [],
                grandsons: [],
                master: [{
                    areaVisible: areaVisible[pk_area],
                    classify: 'master',
                    ...ele,
                }],
            };

            if (groups) { // 表单的
                groups.forEach(gele => {
                    relations[code].groups.push({
                        areaVisible: areaVisible[gele.pk_area],
                        classify: 'group',
                        ...gele,
                    });
                });
            }
            if (sides) {
                sides.forEach(sele => {
                    if (sele.areastatus === 'edit') {
                        relations.__side[code] = sele.code;
                        relations[code].sides.push({
                            areaVisible: areaVisible[sele.pk_area],
                            classify: 'side',
                            ...sele,
                        });
                    } else {
                        relations[code].groups.push({
                            areaVisible: areaVisible[sele.pk_area],
                            classify: 'group',
                            ...sele,
                        });
                    }
                });
            }
            if (grandsons) {
                grandsons.forEach(gsele => {
                    relations[code].grandsons.push({
                        areaVisible: areaVisible[gsele.pk_area],
                        classify: 'grandson',
                        ...gsele,
                    });
                });
            }
        });
        selectOptions = this.handleSelectOptions(selectOptions, relations);
        // console.log('sourceData for', relations, selectOptions);
        return { relations, selectOptions };
    }

    // 规整selectOptions的顺序
    handleSelectOptions(data = [], relations = {}) {
        //  多页签时要调整顺序  移动设置区域之后 这里的顺序需要调整下
        let associatedtabs = relations.__associatedtab,
            associatedtabList = {},
            arr = JSON.parse(JSON.stringify(data)) || [];
        arr.forEach((item, index) => {
            let { code } = item,
                acode = associatedtabs[code];
            if (acode) {
                !associatedtabList[acode] && (associatedtabList[acode] = []);
                associatedtabList[acode].push(item);
                arr.splice(index, 1);
            }
        });

        arr.forEach((item, index) => {
            let { code } = item;
            if (associatedtabList[code]) {
                arr.splice(index + 1, 0, ...associatedtabList[code]);
            }
        });

        return arr;
    }

    // 选中激活
    active($title) {
        // 清理选中状态
        let $prevSelector = document.querySelector(`.${SIGN.sus}`);
        let $unit = $title.querySelector(`.${SIGN.sua}`);
        if ($unit) {
            $prevSelector && ($prevSelector.className = $prevSelector.className.replace(new RegExp(`${SIGN.sus}`, 'g'), ''));
            $unit.className += ` ${SIGN.sus}`;
            this.focus($unit);
        }
    }

    // 聚焦
    focus($unit) {
        // 处理是否滚动
        setTimeout(() => {
            $unit.scrollIntoView();
        }, 10);
    }

    // 清理侧拉
    clearSide(ele, callback) {
        let { curentSide, showSide } = this.state,
            { code: sideCode, relationcode: sideRelationcode, isgrandson: sideIsgrandson, classify: sideClassify } = curentSide,
            { code, relationcode, areastatus, isgrandson, classify } = ele.area,
            relations = this.relations;

        let condition = classify == 'master' || // 主表区域一定关闭
            classify == 'group' || // 下拉或者分组 一定关闭
            (classify == 'side' && sideRelationcode != relationcode) || // 侧拉不一定关闭 不是同一区域关闭
            (classify == 'grandson' && sideRelationcode != relationcode); // 孙表不一定关闭 不是同一区域关闭

        if (sideCode && showSide && condition) { // 到下个区域  下拉子表  或者主表  才跳转
            let code = sideIsgrandson ? relations.__side[sideRelationcode] : sideCode;
            let $side = document.querySelector(getAreaSelector(code));
            let $closeBtn = $side && $side.querySelector('.drawer-close-btn');

            $closeBtn && $closeBtn.click();
            this.setState({
                curentSide: {},
                showSide: false,
            });
            // 锁一点时间
            this.lockService(callback);
        } else {
            callback();
        }
    }

    /**
     * 操作锁
     * @param {*} f
     * @param {*} time
     */
    lockService = (f, time = 250) => {
        this.lock = true;
        setTimeout(() => {
            this.lock = false;
            f && f();
        }, time);
    }

    /**
     * 定位区域单元
     * @param {*} $master
     * @param {*} unitCode
     * @param {*} areaCode
     * @param {*} relationcode
     * @param {*} isgrandson
     * @param {*} areastatus
     */
    positionAreaUnit($master, { unitCode, areaCode, relationcode, isgrandson, areastatus, areatype, associatedtab, classify }) {
        let $title = null;
        if (classify == 'side' || classify == 'grandson') { // 侧拉情况
            let searchInSide = $master.getAttribute('searchinside'), // 侧拉是否展开
                $sideOpr = $master.querySelector('.search-action-side');
            this.setState({
                curentSide: {
                    code: areaCode,
                    relationcode,
                    isgrandson,
                    classify,
                },
                showSide: true,
            });

            $sideOpr && searchInSide != "true" && $sideOpr.click(); // 主区域展开侧拉
            // 添加锁  避免频繁操作
            this.lockService(() => {
                if (isgrandson) { // 在侧拉孙表中
                    this.highlight();
                    let $content = document.querySelector(`.search-area-${replaceStr(areaCode)} .area-item-content`);
                    let $header = document.querySelector(`.search-area-${replaceStr(areaCode)} .search-area-header`);
                    // 孙表未展开
                    $content && $content.style.display == 'none' && $header && $header.click();

                    $title = document.querySelector(getLabelSelector(areaCode, unitCode));
                } else if (areastatus == 'edit') { // 在侧拉子表
                    this.highlight();
                    $title = document.querySelector(getLabelSelector(areaCode, unitCode));
                }
                $title && this.active($title);
            });
        } else {
            // 获取信息
            let $current = document.querySelector(getAreaSelector(areaCode)), // 当前区域
                $content = $master.querySelector('.area-item-content'),
                $header = $master.querySelector('.search-area-header'),
                $fold = $master.querySelector('.form-area-group'),
                $foldOpr = $master.querySelector('.search-action-fold');
            // 主表展开
            $content && $content.style.display == 'none' && $header && $header.click();
            // 分组展开
            if ($fold && $fold.style.display == 'none' && $foldOpr && areastatus == 'browse') {
                $foldOpr.click();
            }

            // 解决首次不能正确聚焦的问题（dom渲染的过程中  calss添加不上去）
            this.lockService(() => {
                if (areastatus == 'browse' && associatedtab) { // 区分多页签情况下的分组
                    $current = document.querySelector(getAreaSelector(relationcode) + getAreaSelector(areaCode));
                }

                // 查询区模式
                if (areatype == '0') {
                    $title = $current && $current.querySelector(getUnitSelector(unitCode));
                    // 清理选中状态
                    let $prevSelector = document.querySelector(`.${SIGN.sus}`);
                    if ($title) {
                        $prevSelector && ($prevSelector.className = $prevSelector.className.replace(new RegExp(`${SIGN.sus}`, 'g'), ''));
                        $title.className += ` ${SIGN.sus}`;
                        this.focus($title);
                    }
                } else {
                    $title = $current && $current.querySelector(getUnitSelector(unitCode) + getUnitLabelSelector());
                    $title && this.active($title);
                }
            });

        }
    }

    // 定位
    position(index = 1) {
        let { highlights } = this.state,
            relations = this.relations,
            ele = highlights[index - 1];

        if (!highlights || !ele) {return;} // 未找到待定位数据

        // 多页签
        let { code: areaCode, relationcode, isgrandson, areastatus, areatype, classify } = ele.area,
            { code: unitCode } = ele.unit,
            associatedtab = relations.__associatedtab[relationcode || areaCode],
            masterCode = areaCode;

        if (associatedtab) {
            masterCode = associatedtab;
        } else if (classify == 'group' || classify == 'side' || classify == 'grandson') { // 分组 侧拉 孙表 子表
            masterCode = relationcode;
        }

        // 获取主区域 主区域下有很多情况 包括groups sides grandsons  tabs
        let $master = document.querySelector(getAreaSelector(masterCode));
        if (!$master) {return;} // 找不到主区域

        // 清理侧拉
        this.clearSide(ele, () => {
            if (associatedtab) {
                let $tabsContainer = $master.querySelector('.table-tabs-container') || closest($master, '.table-tabs-container'),
                    tabsCodes = JSON.parse($tabsContainer.getAttribute('data-searchcodes') || '[]'), // 为啥这样获取 因为有顺序
                    index = tabsCodes.indexOf(relationcode || areaCode),
                    $actveTab = $tabsContainer.querySelector(`.wui-tabs-tab.wui-tabs-tab-active`),
                    $tabbar = $tabsContainer.querySelectorAll(`.wui-tabs-tab`)[index]; // 目标页签

                // console.log('多页签定位'); // , ele, tabsCodes, index, $tabbar

                if ($tabbar && $actveTab !== $tabbar) { // 避免多次点击页签
                    $tabbar.click();
                    this.lockService(() => {
                        this.highlight();
                        this.positionAreaUnit($master, { unitCode, areaCode, relationcode, isgrandson, areastatus, areatype, associatedtab, classify });
                    });
                } else {
                    this.positionAreaUnit($master, { unitCode, areaCode, relationcode, isgrandson, areastatus, areatype, associatedtab, classify });
                }
            } else {
                this.positionAreaUnit($master, { unitCode, areaCode, relationcode, isgrandson, areastatus, areatype, associatedtab, classify });
            }
        });
    }

    // 高亮
    highlight() {
        let { highlights = [] } = this.state;
        // 遍历所有高亮项  然后添加样式
        for (const ele of highlights) {
            let { key, label, code: unitCode } = ele.unit,
                { code: areaCode, areatype, areastatus, relationcode, associatedtab, isgrandson, classify } = ele.area,
                selector = null,
                $title = null;
            if (areatype == '0') { // 查询区
                selector = getAreaSelector(areaCode) + getUnitSelector(unitCode);
            } else if (classify == 'group') { // 分组
                selector = getAreaSelector(relationcode) + getLabelSelector(areaCode, unitCode);
            } else { // classify == 'master'  classify == 'side' || associatedtab || isgrandson
                selector = getLabelSelector(areaCode, unitCode);
            }

            if (!selector) {continue;}

            $title = document.querySelector(selector);

            //处理code相同但label不同的情况
            //在一个区域内找相同字段
            let hasRepeatItems = this.isRepeat(areaCode);
            if (hasRepeatItems) {
                let allSelector = document.querySelectorAll(selector);
                if ([...allSelector].length > 1) {
                    [...allSelector].forEach(sel => {
                        if (sel.innerText.search(key) != -1) {
                            $title = sel;
                        }
                    });
                }
            }
            if (!$title) {continue;}
            if (areatype == '0') { // 查询区类型
                $title.setAttribute('tabindex', 0);
                $title.className += ` ${SIGN.sua} ${SIGN.sun}`;
            } else {
                $title.innerHTML = String(label).replace(key, `<span tabindex="0" class="${SIGN.sua}">${key}</span>`);
            }
        }
    }

    //判断同区域内是否有相同code的字段
    isRepeat = areaCode => {
        let { areaList } = this.props;
        const targetArea = areaList.find(area => area.code === areaCode);
        let repeatItems = false;
        if (targetArea) {
            let uniqItems = uniqBy(targetArea.queryPropertyList, "code");
            return targetArea.queryPropertyList.length !== uniqItems.length;
        }
        return repeatItems;
    }

    /**
     * 清理所有的已选项
     */
    clearAllHightLight() {
        let $title = document.querySelectorAll(`.${SIGN.sua}`);
        $title && Array.from($title).forEach(ele => {
            ele.className = ele.className.replace(new RegExp(`${SIGN.sua}`, 'g'), '');
            ele.className = ele.className.replace(new RegExp(`${SIGN.sus}`, 'g'), '');
        });
    }

    /**
     * 获取所有的匹配数据
     * @param {String} key
     */
    getHighlights(key) {
        let searchData = [],
            { showSide = false, select, selectOptions } = this.state,
            highlights = [],
            relations = this.relations;

        // 根据前面的下拉选项区分搜索范围
        if (select && select != 'All') {
            searchData = [].concat(relations[select].master, relations[select].groups, relations[select].sides, relations[select].grandsons);
        } else {
            let data = [];
            for (const iterator of selectOptions) {
                data = data.concat(relations[iterator.code].master, relations[iterator.code].groups, relations[iterator.code].sides, relations[iterator.code].grandsons);
            }
            searchData = data;
        }

        key && searchData.forEach(ele => {
            // areatype '0'  查询区  '1' 表单区  '2'  表格区
            let { relationcode, code, areastatus, name, queryPropertyList, isgrandson, areatype, classify, associatedtab, areaVisible } = ele;
            // 查找对应数据
            queryPropertyList.forEach(item => {
                let { label = '', code: icode, visible } = item;
                if (areaVisible && !visible) { // 区域隐藏被隐藏元素
                    return;
                }
                let curLabel = this.getMultiLangName(item, 'label');
                if (toLocaleLowerCase(label).indexOf(toLocaleLowerCase(key)) != '-1' ||
                    toLocaleLowerCase(curLabel).indexOf(toLocaleLowerCase(key)) !== -1
                ) {
                    // 侧边模式  和非侧边模式
                    // ((!showSide && areastatus != 'edit') || showSide)
                    highlights.push({
                        // 避免自身数据和 子数据混乱 加入区分
                        area: {
                            relationcode,
                            code,
                            areastatus,
                            name,
                            isgrandson,
                            areatype,
                            classify,
                            associatedtab,
                        },
                        unit: {
                            code: icode,
                            key: getOriginalStr(curLabel, key),
                            label: curLabel,
                        },
                    });
                }
            });
        });
        console.log('search for', highlights);
        return highlights;
    }

    // 查找
    search(key, position = 1) {
        let highlights = this.getHighlights(key);
        this.setState({
            highlights,
            current: position,
            total: highlights.length,
            key,
        }, () => {
            // 清理上次已选
            this.clearAllHightLight();
            this.highlight();
            this.position(position);
            // 一旦进行了查找  这个重新查询可以为false 并没有用
            this.reset = false;
        });
    }

    /**
     * 文本框内容变化
     */
    handleChange = key => {
        this.search(key);
        this.setState({ key });
    }

    /**
     * 清空
     */
    clear = () => {
        this.clearAllHightLight();
        this.setState({
            highlights: [],
            key: '',
            current: 0,
            total: 0,
        });
    }

    /**
     * 移动查询
     */
    moveSearch(dir = 'next') {
        let { highlights, current, total = -1, key } = this.state;
        if (!this.reset && (total <= 0 || !highlights.length || this.lock)) {
            return;
        }
        // 重查
        if (this.reset) {
            let oldItem = JSON.parse(JSON.stringify(highlights[current - 1] || { area: {}, unit: {} })),
                oldHighlight = JSON.parse(JSON.stringify(highlights || []));
            dir == 'prev' ? oldHighlight.splice(current, oldHighlight.length) : oldHighlight.splice(0, current - 1); // 去除一部分数据

            // console.log(oldHighlight);
            highlights = this.getHighlights(key);

            let newCurrent = 0,
                first = true;

            if (dir == 'prev') {
                for (let index = highlights.length - 1; index >= 0; index--) {
                    let item = highlights[index];
                    if (oldHighlight.some(iitem => iitem.area.code === item.area.code & item.unit.code == iitem.unit.code)) { // 重新查找索引
                        newCurrent = item.area.code == oldItem.area.code && item.unit.code == oldItem.unit.code ? index + 1 : index + 2;
                        break;
                    }
                }
            } else {
                highlights.forEach((item, index) => {
                    if (oldHighlight.some(iitem => iitem.area.code === item.area.code & item.unit.code == iitem.unit.code) && first) { // 重新查找索引
                        newCurrent = item.area.code == oldItem.area.code && item.unit.code == oldItem.unit.code ? index + 1 : index; // 如果是老数据  则定位下一个 否则当前
                        first = false;
                    }
                });
            }

            total = highlights.length;

            current = newCurrent ? newCurrent : (dir == 'prev' ? 2 : 0); // 如果没找到 回到第一个

            this.reset = false;
        }

        current = dir == 'prev' ? (current > total || current == 1 ? total : current - 1) : (current >= total ? 1 : current + 1);

        if (total == 1 && current == 1) {
            this.position(current);
        } else {
            this.setState({
                current,
                total,
                highlights,
            }, () => {
                this.clearAllHightLight();
                this.highlight();
                this.position(current);
            });
        }
    }

    /**
     * 上一个
     */
    prev = () => {
        this.moveSearch('prev');
    }

    /**
     * 下一个
     */
    next = () => {
        this.moveSearch('next');
    }

    componentWillUnmount() {
        this.sourceData = [];
        this.areaList = [];
    }
    getMultiLangName(ele, propertyKey) {
        let { multiOptions } = this.props;
        let local = getLangCode('langCode');
        let localTitle = '';
        let mainTitle = '';
        let itemKey = '';
        let ret;
        if (!multiOptions) {
            return _.get(ele, name, '');
        }
        multiOptions.forEach(opt => {
            let { languageMain, index, languageCode } = opt;
            itemKey = `${propertyKey}${index}`;
            if (languageCode === local) {
                localTitle = _.get(ele, itemKey);
            }
            if (languageMain === true) {
                mainTitle = _.get(ele, itemKey);
            }
        });
        ret = localTitle && localTitle.length > 0 ? localTitle : mainTitle;
        return ret;
    }

    render() {
        let { current, total, selectOptions, key, select, selectFocus } = this.state;
        return (
            <div className="search-box search-box-header">
                <NCSelect
                    className={`st-select ${selectFocus ? 'st-select-focus' : ''}`}
                    value={select}
                    showClear={false}
                    fieldid="searchProperty" //自动化测试标记
                    onFocus={() => {
                        this.setState({ selectFocus: true });
                    }}
                    onBlur={() => {
                        this.setState({ selectFocus: false });
                    }}
                    onSelect={value => {
                        this.setState({ select: value }, () => {
                            this.search(key);
                        });
                    }}
                >
                    <NCOption value="All">{langCheck('ZoneSetting-000282', 'pages', this.props.json) || '全部'}</NCOption>
                    {
                        selectOptions.map(ele => <NCOption value={ele.code}><span title={ele.name}>{ele.name}</span></NCOption>)
                    }
                </NCSelect>
                <NCFormControl
                    className={`st-input ${selectFocus ? 'st-input-border-left' : ''}`}
                    placeholder={langCheck('ZoneSetting-000281', 'pages', this.props.json) || '搜索字段名称'}
                    onChange={this.handleChange}
                    // onBlur={this.handleChange}
                    prefix={<i className="icon iconfont icon-sousuo st-icon-sousuo" />}
                    value={key}
                    fieldid="searchCon" //自动化测试标记
                />
                {/* <i className="icon iconfont icon-sousuo st-icon-sousuo" /> */}
                {
                    key && <div className="st-count">{`${total ? current : 0}/${total}`}</div>
                }
                {
                    key &&
                    <div className="st-icon">
                        <i className="icon iconfont icon-qingkong st-icon-close" onClick={this.clear} />
                        <i className="icon iconfont icon-jiantoushang1 st-icon-up" onClick={this.prev} />
                        <i className="icon iconfont icon-jiantouxia1 st-icon-down" onClick={this.next} />
                    </div>
                }

            </div>
        );
    }
}

export default connect(
    // 这些都没有用
    state => {
        let { areaList, boxStatus, newAreaList } = state.zoneSettingData;
        // console.log(boxStatus, 'boxStatus');
        return { areaList, boxStatus };
    },
    { updateSearchBox },
)(SearchBox);
